// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__lkRZq","title":"InfoRow_title__oEHFt"};